import React from 'react';
import { getOrgTermsContent } from '../../content/utils.js';
import AuthorizedAction from '../AuthorizedAction.js';
import Tabs from '../Tabs.jsx';
import {
  ChangeImpactReportsLink,
  ProjectReportsLink,
} from '../links/index.jsx';

const ReportsTabs = ({ slug }) => {
  const isProjectsReport =
    window.location.pathname.split('/')[1] === 'project-reports';
  const isChangeImpactReport =
    window.location.pathname.split('/')[1] === 'change-impact-reports';

  return (
    <Tabs>
      {!isProjectsReport ? (
        <Tabs.Tab label={`${getOrgTermsContent('projectReports')}`}>
          <ProjectReportsLink />
        </Tabs.Tab>
      ) : (
        <div
          className={`component-border-left tab ${isProjectsReport && 'tab-active'}`}
        >
          <a className="tab-link component">
            {getOrgTermsContent('projectReports')}
          </a>
        </div>
      )}

      <AuthorizedAction action="read" subject="changeImpact">
        {!isChangeImpactReport ? (
          <Tabs.Tab label="Change Impact Reports">
            <ChangeImpactReportsLink />
          </Tabs.Tab>
        ) : (
          <div
            className={`component-border-left tab ${isChangeImpactReport && 'tab-active'}`}
          >
            <a className="tab-link component">Change Impact Reports</a>
          </div>
        )}
      </AuthorizedAction>
    </Tabs>
  );
};

export default ReportsTabs;
